import useGetOffers from './useGetOffers'

export default useGetOffers
